import { processLocationString } from './processLocation';

export const getNewSearchParams = (asPath, addCustomParams) => {
  const query = processLocationString(asPath.split('?')[1] || '');

  const params = new URLSearchParams();
  Object.keys(query)
    .forEach((key) => {
      if (query[key]) {
        params.set(key, query[key]);
      }
    });

  params.delete('p');

  addCustomParams(query, params);

  return params;
};
